import { PackContext } from '@rhg/providers/pack-provider';
import { useContext } from 'react';

export const usePackContext = () => {
    return useContext(PackContext);
};
